export default "__VITE_PUBLIC_ASSET__fb467127__"